import { PlatformerLevel } from '../../../shared/CharacterTypes';
import { ILevelProvider, SavedMapInfo } from '../../../shared/interfaces/ILevelProvider';
import { LevelRegistry } from './LevelRegistry';

/**
 * A fallback, purely synchronous map provider that only reads built-in levels from the engine's LevelRegistry.
 * Used by the backend and automated tests when a MongoDB or HTTP Web provider isn't injected.
 */
export class RegistryLevelProvider implements ILevelProvider {
  private registry = LevelRegistry.getInstance();

  public async loadLevel(levelId: string): Promise<PlatformerLevel | null> {
    return this.registry.getLevel(levelId) || null;
  }

  public getAvailableMaps(): SavedMapInfo[] {
    return this.registry.getAllLevels().map(level => ({
      id: level.id,
      name: level.name,
      savedAt: 0,
      isBuiltIn: true,
      description: 'Built-in official game map'
    }));
  }

  public saveLevel(level: PlatformerLevel): string | null {
    // Cannot save to static memory registry (or we could, but choosing not to for strictness)
    this.registry.registerLevel(level);
    return level.id;
  }

  public saveToTestMap(_level: PlatformerLevel): boolean {
    return false;
  }

  public getDevMap(): PlatformerLevel | null {
    return null;
  }
}
